import { render, staticRenderFns } from "./BgHeaderContainer.vue?vue&type=template&id=da0e4cdc"
import script from "./BgHeaderContainer.vue?vue&type=script&lang=js"
export * from "./BgHeaderContainer.vue?vue&type=script&lang=js"
import style0 from "./BgHeaderContainer.vue?vue&type=style&index=0&id=da0e4cdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports